import { component$, QRL } from '@builder.io/qwik';
import Button from './Button';
import Arrow from '~/icons/arrow';
import { PLAYLIST_CONFIG } from '~/constants/PLAYLIST';

export const ShowMoreButton = component$<{
  showLessMode: boolean;
  itemsToShow: number;
  onToggle: QRL<() => void>;
}>(({ showLessMode, itemsToShow, onToggle }) => {
  const remainingItems = Math.min(
    PLAYLIST_CONFIG.ITEMS_PER_LOAD,
    PLAYLIST_CONFIG.MAX_ITEMS - itemsToShow
  );

  const buttonText = showLessMode ? 'Show Less' : 'Show More';
  const ariaLabel = showLessMode
    ? 'Show less videos'
    : `Show ${remainingItems} more videos`;

  return (
    <div class='flex justify-center mt-4 w-full'>
      <Button
        onClick$={onToggle}
        size='default'
        variant='primary'
        borderRadius='pill'
        fullWidth={true}
        class='py-3 font-group-big active:bg-primary focus:bg-primary active:scale-95 transition-all duration-150'
        ariaLabel={ariaLabel}
      >
        <span class='flex items-center justify-center gap-2 text-secondary font-industry'>
          <span>{buttonText}</span>
          <ArrowIcon isExpanded={showLessMode} />
        </span>
      </Button>
    </div>
  );
});

const ArrowIcon = component$<{ isExpanded: boolean }>(({ isExpanded }) => (
  <div
    class={`ml-[2px] font-extrabold aspect-3/2 [&_svg]:fill-secondary [&_svg]:w-3 [&_svg]:h-3 ${
      isExpanded ? 'rotate-[-90deg]' : 'rotate-90'
    }`}
  >
    <Arrow direction='right' />
  </div>
));
